import { destinations, CLUSTER } from '../../../constants';
import { FacebookTracker } from '@buzzfeed/third-party-analytics';
import cookies from '@buzzfeed/bf-utils/lib/cookies';

let trackingInstances = {};

const fb = (destination, buzz) => {
  /*
    initialize only when an instace does not exist (an inital request)
    or destination has been changed (switched between bfo and bfn)
  */
  if (buzz?.hasVideoSubbuzz) {
    console.info('Disabled the Facebook Pixel on posts that include a video');
    return {
      trackEvent: () => {}
    };
  }

  if (!buzz?.isShopping) {
    console.info('Disabled the Facebook Pixel on non-shopping posts');
    return {
      trackEvent: () => {}
    };
  }

  if (!trackingInstances[destination]) {
    const { facebook_tracking_id } = destinations[destination];
    trackingInstances[destination] = new FacebookTracker({
      trackingId: facebook_tracking_id,
      cluster: CLUSTER,
    });
  }
  return trackingInstances[destination];
};

// Page view
export async function trackFacebookPageView(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({ eventType: 'PageView', eventData });
}

// Links
export async function trackFacebookAffiliateClick(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);

  const hashedEmail = cookies.get('hem');
  if (hashedEmail) {
    eventData.em = atob(hashedEmail.replace(/"/g, ''));
  }
  tracker.trackEvent({ eventType: 'AddToCart', eventData });
  tracker.trackEvent({ eventType: 'Purchase', eventData });
}

// Newsletter signup
export async function trackFacebookNewsletterSignup(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({
    eventType: 'newsletterSignup',
    eventData,
    options: { custom: true },
  });
}

// Sharing
export async function trackFacebookShareClick(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({
    eventType: 'Share',
    eventData,
    options: { custom: true },
  });
}

export async function trackFacebookLead(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({
    eventType: 'Lead',
    eventData,
  });
}

// Quizzes
export async function trackFacebookQuizComplete(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({
    eventType: 'CompletedQuiz',
    eventData,
    options: { custom: true },
  });
}

export async function trackFacebookQuizAnswer(destination, buzz, eventData) {
  const tracker = await fb(destination, buzz);
  tracker.trackEvent({
    eventType: 'QuizAnswer',
    eventData,
    options: { custom: true },
  });
}
